import { FC, SVGProps } from 'react';

const HomeIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" {...props} fill="none">
      <path
        d="M3.74756 7.31281V14.542C3.74756 15.952 4.8908 17.0952 6.3008 17.0952H13.7002C15.1102 17.0952 16.2535 15.952 16.2535 14.542V7.31281"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 8.29676L11.2284 3.33217C10.5084 2.76298 9.49158 2.76298 8.77158 3.33217L2.5 8.29676"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.7231 4.11945V6.08071"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.03613 17.0952V13.9963C8.03613 13.3292 8.03613 12.9956 8.16021 12.7383C8.28301 12.4837 8.48851 12.2781 8.74317 12.1553C9.00051 12.0313 9.33409 12.0312 10.0013 12.0312C10.6684 12.0312 11.002 12.0313 11.2593 12.1553C11.5139 12.2781 11.7195 12.4837 11.8423 12.7383C11.9663 12.9956 11.9663 13.3292 11.9663 13.9963V17.0952"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HomeIcon;
